import { Anchor, Badge, Box, Card, Grid, Tooltip } from '@mantine/core';
import { IconHistory } from '@tabler/icons-react';
import { useLocation } from 'react-router';
import GoogleStatsVisualizer from '../GoogleStatusVisualizer';
import GoogleAdStats from './GoogleAdStats';

const GoogleAdsCard = ({ googleAd, stats, period, statuses }) => {
  const location = useLocation();

  return (
    <Card mb="md" data-tour="campaignCard" withBorder>
      <Card.Section inheritPadding py="sm">
        <Anchor href={`#${location.pathname}/${googleAd.id}/details`} fw={600}>
          {googleAd.name}
        </Anchor>
        <Box>
          <Tooltip
            label={
              <>
                <div>Created: {new Date(googleAd.createdAt).toLocaleString()}</div>
                <div>Updated: {new Date(googleAd.updatedAt).toLocaleString()}</div>
              </>
            }
            position="top"
            withArrow
          >
            <Badge variant="default" style={{ cursor: 'pointer' }}>
              <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
            </Badge>
          </Tooltip>
        </Box>
      </Card.Section>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <GoogleAdStats googleAd={googleAd} stats={stats} period={period} />
        </Grid>
        {statuses && <GoogleStatsVisualizer statuses={statuses} type={'campaign'} />}
      </Card.Section>
    </Card>
  );
};

export default GoogleAdsCard;
